import { cn } from "@/lib/utils";

const EYEBROW_CLASS = "mb-4 font-accent text-lg italic text-white/60";
const TITLE_CLASS =
  "font-display text-4xl leading-[1.05] tracking-tight text-white sm:text-5xl";

/**
 * Shared section eyebrow + H2 pair used across landing sections.
 * Outer section layout (margins, flex rows, sticky columns) stays in the parent.
 * Pass `reveal` to attach `data-reveal` for useScrollReveal consumers.
 * Pass `titleClassName` for section-specific max-width / lg size utilities.
 */
export default function SectionHeading({
  eyebrow,
  title,
  reveal = false,
  className = "",
  titleClassName = "",
  as: TitleTag = "h2",
}) {
  const revealProps = reveal ? { "data-reveal": true } : {};

  return (
    <div className={className}>
      {eyebrow != null && eyebrow !== "" && (
        <p
          {...revealProps}
          className={EYEBROW_CLASS}
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {eyebrow}
        </p>
      )}
      {title != null && title !== "" && (
        <TitleTag
          {...revealProps}
          className={cn(TITLE_CLASS, titleClassName)}
          style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
        >
          {title}
        </TitleTag>
      )}
    </div>
  );
}
